import React, { useContext, useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { useLocation,Link } from "react-router-dom";
import { CommonDataContext } from "contexts/CommonDataContext/CommonDataContext";
import { useTranslation } from "react-i18next"; 

function BeneficiaryDropdown({ className, dropdownTitle }) {

  const location = useLocation();
  const context = useContext(CommonDataContext)
  const countryList = context?.countries;

  const { t } = useTranslation();

  const isActive = location?.pathname?.includes('country');
  return (
    <Dropdown className={`dropdown-beneficiary ${isActive ? "active" : ""}`}>
      <Dropdown.Toggle className={className} id="dropdown-beneficiary">{dropdownTitle}</Dropdown.Toggle>
      <Dropdown.Menu>
        {countryList?.map(country =>{

          // convert country name like "Serbia" → translation key "country.serbia"
          const countryKey = `country:${country?.name?.toLowerCase().replace(/\s+/g, "-")}`;
          const translatedCountry = t(countryKey, country?.name); // fallback to original if not found

          return  <Dropdown.Item key={country?.id}><Link to={`/country/${country?.name}`} >
            {/* {country?.name} */}
            {translatedCountry}
            </Link></Dropdown.Item>
        })}
        {/* <Dropdown.Item><Link to="/country/bosnia" >Bosnia and Herzegovina</Link></Dropdown.Item>
        <Dropdown.Item><Link to="/country/kosovo">Kosovo</Link></Dropdown.Item>
        <Dropdown.Item><Link to="/country/montenegro">Montenegro</Link></Dropdown.Item>
        <Dropdown.Item
         
       
        >
          <Link to="/country/macedonia">North Macedonia</Link>
        </Dropdown.Item>
        <Dropdown.Item><Link to="/country/serbia">Serbia</Link></Dropdown.Item> */}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default BeneficiaryDropdown;
